import Modal, { ModalBody, ModalFooter, ModalHeader, Prompt } from '@ingka/modal';
import Text from '@ingka/text';
import Button from '@ingka/button';
import { useTranslation } from 'react-i18next';
import List from '@ingka/list';
import styles from './InvalidateWinnersModal.module.scss';

export type InvalidateWinnersModalProps = {
  visible: boolean;
  partyUids: Set<string>;
  replace: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const InvalidateWinnersModal: React.FC<InvalidateWinnersModalProps> = ({
  visible,
  partyUids,
  replace,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();
  const invalidateWinnersModalTitle = replace
    ? t('invalidate-winners-modal-replace-title')
    : t('invalidate-winners-modal-title');

  return (
    <Modal visible={visible} handleCloseBtn={onClose}>
      <Prompt
        aria-labelledby={invalidateWinnersModalTitle}
        title={
          replace
            ? t('invalidate-winners-modal-replace-title')
            : t('invalidate-winners-modal-title')
        }
        titleId={invalidateWinnersModalTitle}
        header={<ModalHeader ariaCloseTxt={`${t('general-close-prompt')}`} />}
        footer={
          <ModalFooter>
            <Button text={`${t('general-cancel')}`} type="secondary" onClick={onClose} />
            <Button
              text={`${
                replace
                  ? t('invalidate-winners-modal-replace-title')
                  : t('invalidate-winners-modal-title')
              }`}
              type="primary"
              onClick={onConfirm}
            />
          </ModalFooter>
        }
      >
        <ModalBody className={styles['modal-body']}>
          <Text className={styles['body-text']}>
            {replace
              ? t('invalidate-winners-modal-replace-text')
              : t('invalidate-winners-modal-text')}
          </Text>

          <List variation={'small'}>
            {Array.from(partyUids).map((listItem) => {
              return <li key={listItem}>{listItem}</li>;
            })}
          </List>
        </ModalBody>
      </Prompt>
    </Modal>
  );
};
